import React from 'react';
import { Activity } from '../../model/activity';
import { Comment, CommentAction } from './Comment';

interface Props {
  comments: Activity[];
  actions?: CommentAction[];
  readOnly?: boolean;
  onChange?: () => void;
  onReply?: () => void;
  onFlag?: () => void;
}

export function CommentList({ comments, onChange, readOnly, actions, onReply, onFlag }: Props): JSX.Element {
  return (
    <>
      {comments.map((item) => {
        return (
          <div key={item.id} className="activities__line">
            <Comment
              actions={actions}
              activity={item}
              readOnly={readOnly}
              onChange={onChange}
              onReply={onReply}
              onFlag={onFlag}
            ></Comment>
          </div>
        );
      })}
    </>
  );
}
